import React  from 'react';

class ParticleList extends React.Component {
	constructor() {
		super();
		this.state = {
			LightningModule: null,
			timeline: null,
			timelinePlayer: null
		};
        this.showLightning = this.showLightning.bind(this);
	}
	showLightning() {
		let LightningModule = this.state.LightningModule;
		let timeline = this.state.timeline;
		let timelinePlayer = this.state.timelinePlayer;
		if (LightningModule === null) {
			let terrainview = window.main.OView;
			let initialPos = new window.GeoPoint(120.19522435571207, 22.77798280649094, 1366.059043463517);
			let initialV = new window.Geo3DPoint(0.4576038108900927, 0.8890126321749483, -0.015919964415307384);
			let initialUp = new window.Geo3DPoint(0.007286201300968689, 0.014155312601379129, 0.9999045715165764);
			let initialCamera = new window.ov.Camera(initialPos, initialV, initialUp);
			terrainview.gotoCamera(initialCamera, false);
			
			LightningModule = terrainview.getModule("lightning");
			timeline = new window.ov.Widget.Timeline({
				view: terrainview,
				style: { left: "160px", width: "77%", bottom: "30px" },
				startTime: new Date().getTime(),
				stopTime: new Date().getTime() + 1.5 * 1000.0,
				isRepeat: true
			});
			timelinePlayer = new window.ov.Widget.TimelinePlayer({
				view: terrainview,
				timeline: timeline,
				playSpeed: 1.0,
				style: {left: "100px", bottom: "30px"}
			});
			let LightningStartTime = new Date().getTime() + 0.25 * 1000.0;
			terrainview.addTimeEvent({
				start: LightningStartTime,
				end: LightningStartTime + 1.0 * 1000.0,
				onEnter: function () {
					LightningModule.addLightningEntity({
						position: new window.Geo3DPoint(120.22900665201502, 22.845749565179712, 5000.0),
						endHeight: 0.0,
						color: new window.ov.Color(176, 255, 255),
						minWidth: 10,
						maxWidth: 10,
						splitRate: 0.7,
						completeShowTime: 0.2,
						completeVanishTime: 0.5
					});
				},
				onPlay: function(time){
					LightningModule.setAllEntityTime((time - LightningStartTime) / 1000.0);
				},
				onLeave: function(){
					LightningModule.removeAllLightningEntity();
				}
			});
			timeline.addTimeBlock({
				start: LightningStartTime,
				end: LightningStartTime + 1.0 * 1000.0,
				color: "red"
			});
			this.setState({LightningModule, timeline, timelinePlayer});
		} else {
			LightningModule.removeAllLightningEntity();
			timeline.remove();
			timelinePlayer.remove();
			this.setState({LightningModule: null, timeline: null, timelinePlayer: null});
		}
	}
	render() {
		return (
			<>
				<a className="ts accordion item" id="particle_cloud" onClick={(e) => this.props.setCloudModuleOpen()} style={{margin: "5px", borderLeft: "1px solid #e9e9e9"}}>
					<div><i className="cloud icon"></i>雲模組</div>
				</a>
				<a className="ts accordion item" id="particle_lightning" onClick={(e) => this.showLightning()} style={{margin: "5px", borderLeft: "1px solid #e9e9e9"}}>
					<div><i className="lightning icon"></i>閃電模組</div>
				</a>
				<a className="ts accordion item" id="particle_rain" onClick={(e) => this.props.setParticleRainOpen()} style={{margin: "5px", borderLeft: "1px solid #e9e9e9"}}>
					<div><i className="rain icon"></i>下雨效果</div>
				</a>
				<a className="ts accordion item" id="particle_explosion" onClick={(e) => this.props.setParticleExplosionOpen()} style={{margin: "5px", borderLeft: "1px solid #e9e9e9"}}>
					<div><i className="bomb icon"></i>爆炸</div>
				</a>
			</>
		);
	}
}

class ParticleRain extends React.Component {
	constructor() {
		super();
		this.state = {
			ParticleModule: null,
			rainEntity: null,
			windSpeedX: 0,
			windSpeedY: 0,
			level: window.ov.RAIN.LOW
		};
		this.closeCard = this.closeCard.bind(this);
		this.createRain = this.createRain.bind(this);
		this.clearRain = this.clearRain.bind(this);
	}
	componentDidUpdate() {
		const {ParticleModule, rainEntity} = this.state;
		if (this.props.isOpen) {
			if (rainEntity == null) {
				this.createRain();
			} else {
				this.updateRain();
			}
		}
	}
    componentWillUnmount() {
        this.clearRain();
    }
	closeCard() {
        this.clearRain();
		this.props.setParticleRainOpen();
	}
	windSpeedXChange(e) {
		this.setState({windSpeedX: e.target.valueAsNumber});
	}
	windSpeedYChange(e) {
		this.setState({windSpeedY: e.target.valueAsNumber});
	}
	levelChange(e) {
		const {ParticleModule, rainEntity, windSpeedX, windSpeedY} = this.state;
		ParticleModule.removeParticleEntity(rainEntity);
		let _rainEntity = ParticleModule.addRainEntity({
			windSpeed: new window.GeoPoint(parseInt(windSpeedX), parseInt(windSpeedY)),
			level: parseInt(e.target.value),
		});
		this.setState({rainEntity: _rainEntity, level: e.target.value});
	}
	createRain() {
		const {ParticleModule, rainEntity, windSpeedX, windSpeedY, level} = this.state;
		let _ParticleModule = null;
		let _rainEntity = null;
		if (window.main !== null) {
			if (ParticleModule === null) {
				_ParticleModule = window.main.OView.getModule("particle");
				this.setState({ParticleModule: _ParticleModule});
			} else {
				_ParticleModule = ParticleModule;
			}
			if (rainEntity === null) {
				_rainEntity = _ParticleModule.addRainEntity({
					windSpeed: new window.GeoPoint(parseInt(windSpeedX), parseInt(windSpeedY)),
					level: parseInt(level),
				});
				this.setState({rainEntity: _rainEntity});
				let initialPos = new window.GeoPoint(120.19522435571207, 22.77798280649094, 1366.059043463517);
				let initialV = new window.Geo3DPoint(0.4576038108900927, 0.8890126321749483, -0.015919964415307384);
				let initialUp = new window.Geo3DPoint(0.007286201300968689, 0.014155312601379129, 0.9999045715165764);
				let initialCamera = new window.ov.Camera(initialPos, initialV, initialUp);
				window.main.OView.gotoCamera(initialCamera, false);
			}
		}
	}
	updateRain() {
		const {ParticleModule, rainEntity, windSpeedX, windSpeedY, level} = this.state;
		let ov = window.ov;
		if (rainEntity != null) {
			rainEntity.updateGenerator({
				particleVelocity: new window.Geo3DPoint(parseInt(windSpeedX), parseInt(windSpeedY), (level == ov.RAIN.HIGH) ? -500 : (level == ov.RAIN.MEDIUM) ? -250 : -100)
			});
		} else {
			this.createRain();
		}
	}
	clearRain () {
		const {ParticleModule, rainEntity} = this.state;
		if (ParticleModule !== null) {
			ParticleModule.removeParticleEntity(rainEntity);
			if (rainEntity !== null) this.setState({rainEntity: null});
		}
	}
	render() {
		const isOpen = this.props.isOpen;
		const cardStyle = {
			zIndex: "100",
			transform: isOpen ? 'translate3d(0, 0, 0)' : 'translate3d(120%, 0, 0)',
			position: "fixed",
			top: "3px",
			right: "10px",
			marginTop: "5px",
			width: "300px"
		};
		return (
			<div className="ts card" style={cardStyle}>
				<div className="extra content">
					<div className="actions">
						<div className="ts separated icon buttons">
							<button className="ts circular icon button" onClick={this.closeCard.bind(this)}>
								<i className="remove icon"></i>
							</button>
						</div>
					</div>
					<div className="header">
						<i className="rain icon"></i>
						下雨效果
					</div>
					<div className="meta">
						<div>
							設定下方工具以調整效果
						</div>
					</div>
				</div>
				<div className="content" style={{textAlign: "center"}}>
					<div className="description">
						<div className="ts grid">
							<div className="row" id="surveyingRow">                    
								<div className="four wide column">
									風速(m/s):X
								</div>
								<div className="eight wide column">
									<div class="ts mini circular input">
										<input type="number" placeholder="風速(m/s):X" value={this.state.windSpeedX} onChange={(e)=>this.windSpeedXChange(e)}></input>
									</div>
								</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column">
								    風速(m/s):Y
								</div>
								<div className="eight wide column">
									<div class="ts mini circular input">
										<input type="number" placeholder="風速(m/s):Y" value={this.state.windSpeedY} onChange={(e)=>this.windSpeedYChange(e)}></input>
									</div>
								</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column">
								    雨勢
								</div>
								<div className="eight wide column">
									<div class="ts compact horizontal checkboxes">
										<div class="ts radio checkbox">
											<input id="levelLow" type="radio" value="0" name="level" checked={this.state.level == 0} onChange={(e)=>this.levelChange(e)}></input>
											<label for="levelLow">弱</label>
										</div>
										<div class="ts radio checkbox">
											<input id="levelMedium" type="radio" value="1" name="level" checked={this.state.level == 1} onChange={(e)=>this.levelChange(e)}></input>
											<label for="levelMedium">中</label>
										</div>
										<div class="ts radio checkbox">
											<input id="levelHigh" type="radio" value="2" name="level" checked={this.state.level == 2} onChange={(e)=>this.levelChange(e)}></input>
											<label for="levelHigh">強</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class ParticleExplosion extends React.Component {
	constructor() {
		super();
		this.state = {
			ParticleModule: null,
			explosionEntity: null,
			Size: 10,
			Period: 1,
			rotatePerSec: 0,
			weight: [1, 1, 1]
		};
		this.createExplosion = this.createExplosion.bind(this);
		this.closeCard = this.closeCard.bind(this);
		this.clearExplosion = this.clearExplosion.bind(this);
	}
	componentDidUpdate() {
		if (this.props.isOpen) {
			if (this.state.ParticleModule == null || this.state.explosionEntity == null) {
				this.createExplosion();
			}
		}
	}
	createExplosion() {
		const {ParticleModule, explosionEntity, Size, Period, rotatePerSec, weight} = this.state;
		let _ParticleModule = null;
		let _explosionEntity = null;
		if (window.main !== null) {
			if (ParticleModule === null) {
				_ParticleModule = window.main.OView.getModule("particle");
				this.setState({ParticleModule: _ParticleModule});
			} else {
				_ParticleModule = ParticleModule;
			}
			if (explosionEntity === null) {
				_explosionEntity = _ParticleModule.addExplosionEntity({
					position: new window.Geo3DPoint(120.254343, 22.842091, 20),
					size: Size,
					generatePeriod: Period,
					rotatePerSecond: rotatePerSec,
					rgbWeight: weight
				});
				this.setState({explosionEntity: _explosionEntity});
				let initialPos = new window.GeoPoint(120.25414128635549, 22.841697948009113, 25.165497977162318);
				let initialUp = new window.Geo3DPoint(0.0066371396740791235, 0.012902485293109322, 0.9998947315843842);
				let initialV = new window.Geo3DPoint(0.4573857456478581, 0.8891500176732612, -0.014509505497849934);
				let initialCamera = new window.ov.Camera(initialPos, initialV, initialUp);
				window.main.OView.gotoCamera(initialCamera, false);
			}
		}
	}
	closeCard() {
		this.clearExplosion();
		this.props.setParticleExplosionOpen();
	}
	clearExplosion() {
		const {ParticleModule, explosionEntity} = this.state;
		if (ParticleModule !== null) {
			ParticleModule.removeParticleEntity(explosionEntity);
			this.setState({
				explosionEntity: null,
				Size: 10,
				Period: 1,
				rotatePerSec: 0,
				weight: [1, 1, 1]
			});
		}
	}
	sizeChange(e) {
		let _Size = parseInt(e.target.value);
		this.state.explosionEntity.updateGenerator({particleScale: _Size});
		this.setState({Size: _Size});
	}
	periodChange(e) {
		let _Period = parseInt(e.target.value);
		this.state.explosionEntity.updateGenerator({particleMaxLife: _Period});
		this.setState({Period: _Period});
	}
	rotatePerSecChange(e) {
		let _rotatePerSec = parseInt(e.target.value);
		this.state.explosionEntity.updateGenerator({particleRotatePerSecond: _rotatePerSec});
		this.setState({rotatePerSec: _rotatePerSec});
	}
	weightChange(e, index) {
		const {ParticleModule, explosionEntity, Size, Period, rotatePerSec} = this.state;
		let _weight = this.state.weight;
		_weight[index] = parseFloat(e.target.value);
		ParticleModule.removeParticleEntity(explosionEntity);
		let _explosionEntity = ParticleModule.addExplosionEntity({
			position: new window.Geo3DPoint(120.254343, 22.842091, 20),
			size: Size,
			generatePeriod: Period,
			rotatePerSecond: rotatePerSec,
			rgbWeight: _weight
		});
		this.setState({explosionEntity: _explosionEntity, weight: _weight});
	}
	render() {
		const isOpen = this.props.isOpen;
		const cardStyle = {
			zIndex: "100",
			transform: isOpen ? 'translate3d(0, 0, 0)' : 'translate3d(120%, 0, 0)',
			position: "fixed",
			top: "3px",
			right: "10px",
			marginTop: "5px",
			width: "300px"
		};
		const siderRangeCSS = {
			background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
		return (
			<div className="ts card" style={cardStyle}>
				<div className="extra content">
					<div className="actions">
						<div className="ts separated icon buttons">
							<button className="ts circular icon button" onClick={this.closeCard.bind(this)}>
								<i className="remove icon"></i>
							</button>
						</div>
					</div>
					<div className="header">
						<i className="bomb icon"></i>
						爆炸
					</div>
					<div className="meta">
						<div>
							設定下方工具以調整效果
						</div>
					</div>
				</div>
				<div className="content" style={{textAlign: "center"}}>
					<div className="description">
						<div className="ts grid">
							<div className="row" id="surveyingRow">                    
								<div className="four wide column">
									爆炸大小
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="0" max="30" value={this.state.Size} step="1" onChange={(e)=>this.sizeChange(e)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.Size}</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column" style={{lineHeight: "1.2em"}}>
								    爆炸週期(sec)
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="0" max="5" value={this.state.Period} step="1" onChange={(e)=>this.periodChange(e)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.Period}</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column" style={{lineHeight: "1.2em"}}>
								    每秒旋轉角度
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="-45" max="45" value={this.state.rotatePerSec} step="1" onChange={(e)=>this.rotatePerSecChange(e)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.rotatePerSec}</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column">
								    權重R
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="0" max="10" value={this.state.weight[0]} step="0.1" onChange={(e)=>this.weightChange(e, 0)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.weight[0]}</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column">
								    權重G
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="0" max="10" value={this.state.weight[1]} step="0.1" onChange={(e)=>this.weightChange(e, 1)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.weight[1]}</div>
							</div>
						</div>
						<div className="ts grid">
							<div className="row" id="surveyingRow">
								<div className="four wide column">
								    權重B
								</div>
								<div className="ten wide column">
									<div class="ts mini circular input">
										<input type="range" min="0" max="10" value={this.state.weight[2]} step="0.1" onChange={(e)=>this.weightChange(e, 2)} style={siderRangeCSS}></input>
									</div>
								</div>
								<div class="two wide column">{this.state.weight[2]}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export {ParticleList, ParticleRain, ParticleExplosion};